import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

export type ApprovedContentItem = {
  id: string;
  title: string;
  updatedAt: string;
  type: 'POLICY' | 'PREFACE' | 'ATTACHMENT' | 'RELEASE_NOTES' | 'GUIDE_SHEETS' | 'CRQ' | 'GIQ';
  changes: string[];
  contentType?: 'POLICY' | 'PREFACE';
  changeSetSeverity?: 'MINOR' | 'MAJOR' | 'CRITICAL';
};

export type ApprovedContent = ApprovedContentItem[];

export async function getApprovedContentData(
  manualId?: string,
  onError?: (errors: ServerErrorResponse) => void
): Promise<ApprovedContent> {
  if (!manualId) return [];

  const url = `${baseApiUrl()}/lexiverse-manual-api/v1/manuals/${manualId}/publishable-changes`;

  try {
    const response = await fetcher({
      method: 'get',
      url,
    });

    return response.content.map((item: ApprovedContentItem) => ({
      ...item,
      contentType: item.type === 'POLICY' ? 'POLICY' : item.type === 'PREFACE' ? 'PREFACE' : undefined,
    }));
  } catch (error) {
    onError?.(error as ServerErrorResponse);
    return [];
  }
}

export default getApprovedContentData;
